import * as preact from "preact";

import models from "models/models";

interface Props {}

interface State {}

class ShareBookView extends preact.Component<Props, State> {
  render() {
    const linkUrl = `https://readlang.com/library/${models.bookModel.id}`;

    return (
      <div>
        <p>
          If you're enjoying this text, help out a fellow learner by sharing it!
        </p>

        {models.bookModel.isUserTheOwner() ? (
          <div>
            <p>
              <label>
                <input
                  type="checkbox"
                  checked={models.bookModel.get("public")}
                  onChange={(event) => {
                    models.bookModel.save(
                      { public: event.currentTarget.checked },
                      { patch: true }
                    );
                    this.forceUpdate();
                  }}
                />{" "}
                Make this book public
              </label>{" "}
              <small>
                (only do this if you have permission from the copyright holder)
              </small>
            </p>
          </div>
        ) : null}

        {models.bookModel.get("public") ? (
          <div>
            <p>
              Permanent link:{" "}
              <a style={{ fontSize: "80%" }} href={linkUrl}>
                {linkUrl}
              </a>
            </p>
            <p>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(
                    "https://readlang.com/library/6644c84c96c975de99df39f0"
                  );
                  alert("Link copied to clipboard, now go and share it!");
                }}
              >
                Copy link to clipboard
              </button>
            </p>
          </div>
        ) : null}
      </div>
    );
  }
}

export default ShareBookView;
